import { Deployment } from '@liveauctioneers/hammer-ui-payments/types';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

import { useAppSelector } from '@/redux/hooks';
import { getDeployment } from '@/redux/modules/config';

import { CREATE_USER_RECAPTCHA_SITE_KEY } from './createUserRecaptcha.consts';

export const CreateUserRecaptcha = () => {
    const [shouldRender, setShouldRender] = useState(false);
    const deployment = useAppSelector(getDeployment);

    const isProdEnv = deployment === Deployment.Prod || deployment === Deployment.PreProd;

    useEffect(() => {
        // Since we're using this two places, make sure we don't render duplicate scripts
        if (!window.grecaptcha) {
            setShouldRender(true);
        }
    }, []);

    if (!shouldRender || !isProdEnv || process.env.NODE_ENV === 'test') {
        return null;
    }

    return (
        <Helmet>
            <script
                data-testid="create-user-recaptcha"
                id="create-user-recaptcha"
                key="create-user-recaptcha"
                src={`https://www.google.com/recaptcha/enterprise.js?render=${CREATE_USER_RECAPTCHA_SITE_KEY}`}
                type="text/javascript"
            />
        </Helmet>
    );
};
